import { jsxs as e, jsx as C } from "react/jsx-runtime";
const s = ({
  width: l,
  height: r,
  className: t
}) => /* @__PURE__ */ e(
  "svg",
  {
    className: t,
    fill: "none",
    height: r,
    viewBox: "0 0 11 12",
    width: l,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ C(
        "mask",
        {
          height: "12",
          id: "mask0_1314_47839",
          maskUnits: "userSpaceOnUse",
          style: { maskType: "luminance" },
          width: "11",
          x: "0",
          y: "0",
          children: /* @__PURE__ */ C(
            "path",
            {
              d: "M10.5 0.00556946H0.5V11.9944H10.5V0.00556946Z",
              fill: "currentColor"
            }
          )
        }
      ),
      /* @__PURE__ */ e("g", { children: [
        /* @__PURE__ */ C(
          "path",
          {
            d: "M10.139 2.06369L9.36507 1.39793C9.33599 1.37262 9.30214 1.3534 9.26551 1.34137C9.22888 1.32935 9.19022 1.32478 9.1518 1.32793C9.11338 1.33108 9.07598 1.34189 9.04179 1.35971C9.00761 1.37754 8.97734 1.40202 8.95277 1.43172L5.44483 5.82848C5.43698 5.83849 5.42716 5.84678 5.41597 5.85284C5.40479 5.8589 5.39248 5.8626 5.3798 5.86371C5.36713 5.86482 5.35437 5.86331 5.3423 5.85929C5.33023 5.85526 5.31912 5.8488 5.30965 5.84031L3.66889 4.51047C3.64056 4.48446 3.60733 4.46438 3.57114 4.45138C3.53494 4.43839 3.49652 4.43275 3.45812 4.43479C3.41972 4.43684 3.38212 4.44653 3.34751 4.4633C3.31291 4.48006 3.28199 4.50357 3.25659 4.53243L2.58069 5.29621C2.52903 5.35515 2.50241 5.43193 2.50652 5.5102C2.51062 5.58847 2.54511 5.66205 2.60265 5.71527L4.20117 7.15832L5.34175 8.20597C5.35484 8.21743 5.36898 8.22761 5.384 8.23639L6.41306 7.00793L10.1711 2.48275C10.2208 2.42243 10.2451 2.34513 10.2387 2.26722C10.2324 2.18932 10.1961 2.11693 10.1373 2.06538",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M9.18207 5.32662C9.24619 6.28333 9.0438 7.23908 8.59741 8.08769C8.01032 9.02634 7.1616 9.77285 6.15571 10.2354C5.94111 10.3401 5.72313 10.4348 5.50008 10.5209C5.27872 10.4348 5.05905 10.3401 4.84445 10.2354C3.83794 9.77313 2.9886 9.02658 2.40106 8.08769C1.91979 7.13285 1.71717 6.06177 1.8164 4.99712V2.58245C2.61414 1.98423 3.55018 1.59742 4.5375 1.45798C5.52482 1.31854 6.53137 1.43099 7.46358 1.78488L8.27298 0.771025C7.01907 0.17796 5.62226 -0.0459297 4.24582 0.125527C2.86937 0.296984 1.57017 0.856704 0.500079 1.73926V4.6862C0.366017 6.09729 0.641765 7.5171 1.29427 8.77542C2.10029 10.0246 3.25297 11.0117 4.61127 11.6159C4.9019 11.7545 5.1993 11.8812 5.50008 11.9944C5.80086 11.8812 6.09825 11.7545 6.38889 11.6159C7.74724 11.0118 8.89995 10.0246 9.70589 8.77542C10.3584 7.5171 10.6341 6.09729 10.5001 4.6862V3.73993L9.18207 5.32662Z",
            fill: "currentColor"
          }
        )
      ] })
    ]
  }
);
export {
  s as Content
};
